export const COMPANY_DETAILS = '/';
export const INDUSTRY = '/industry';
export const SOCIAL_MEDIA_SURVEY = '/social-media';
export const INTENT_SURVEY = '/intent-survey';
export const TAGS = '/tags';
export const FILTER = '/filter';
export const BUSINESS_NAME = '/business_name';
export const TAGLINE = '/tagline';
export const DASHBOARD = `/dashboard`;
export const ANY_DASHBOARD = `/dashboard/*`;
export const DASHBOARD_MY_LOGOS = `/dashboard/my-logos`;
export const DASHBOARD_PRINTS = `/dashboard/prints`;
export const DASHBOARD_PRINT_SHOP = `/dashboard/printShop`;
export const DASHBOARD_BRAND_STUDIO = `/dashboard/brand-studio`;
export const LOGO_LIST = '/logo-list';
export const EDIT_LOGO = '/edit-logo';
export const MY_LOGOS = `/my-logos`;
export const PRINTS_EDITOR = `/prints/editor/`;
export const PRINTS_EDITOR_BUSINESS_CARDS = `${PRINTS_EDITOR}business_cards`;
export const PRINTS_EDITOR_WITH_PARAM = `${PRINTS_EDITOR}:editType`;
export const PRINTS_EDITOR_WITH_ITEMID = `${PRINTS_EDITOR}:editType/edit/:itemId`;
export const PRINTS_LOGO_PICKER = `/prints/logo-picker`;
export const PRINTS_CHECKOUT = `/prints/checkout`;
export const PRINTS_THANKYOU = `/prints/thankyou`;
export const PRINTS_PRODUCTS = `/prints/products`;
export const WEBSITE = `/website`;
export const THANK_YOU = `/thankyou`;
export const THANK_YOU_WEBSITE = `/thankyou/website`;
export const SHORTEN = '/shorten';
export const SHARE = '/share';
export const ZOE_EDITOR = '/zoe-editor';
export const ADMIN_PURCHASES = '/admin/purchases';
export const ZOE_TEMPLATES = '/zoe-templates';
export const ZOE_TEMPLATE_ONBOARDING = '/zoe-template-onboarding';
export const ARENA_SPLIT_PAGE_ROUTE = '/arena';
export const PRINTS_STANDALONE = '/print';
export const ARENA_SPLIT_PAGE_BASE_PATH = '/';
export const WELCOME_PAGE_ROUTE = '/welcome';
export const PARTNERS = '/partners';
export const CREATE_BRAND_AFTER_LOGIN = '/createBrand';
export const PREMIUM_CHECKOUT = '/premium-checkout';
export const onBoardingRoutes = [COMPANY_DETAILS, INDUSTRY, SOCIAL_MEDIA_SURVEY, INTENT_SURVEY, TAGS, FILTER, BUSINESS_NAME, TAGLINE];
export const beforeLogInRoutes = [COMPANY_DETAILS, INDUSTRY, SOCIAL_MEDIA_SURVEY, INTENT_SURVEY, TAGS, FILTER, ZOE_TEMPLATES];
export const logoContextRoutes = [DASHBOARD_MY_LOGOS, ZOE_EDITOR, DASHBOARD_BRAND_STUDIO];
export const logoMakerLegacyRoutes = [
    PREMIUM_CHECKOUT,
    ANY_DASHBOARD,
    DASHBOARD,
    DASHBOARD_MY_LOGOS,
    DASHBOARD_PRINTS,
    DASHBOARD_PRINT_SHOP,
    DASHBOARD_BRAND_STUDIO,
    MY_LOGOS,
    WEBSITE,
    PRINTS_EDITOR,
    PRINTS_EDITOR_BUSINESS_CARDS,
    PRINTS_EDITOR_WITH_PARAM,
    PRINTS_EDITOR_WITH_ITEMID,
    PRINTS_LOGO_PICKER,
    PRINTS_CHECKOUT,
    PRINTS_THANKYOU,
    PRINTS_PRODUCTS,
    ZOE_EDITOR
];
//# sourceMappingURL=logoBuilderRoutes.js.map